/**
 * @file     counts.ts
 * @purpose  Listing-count helpers for the property finder. A failed fetch is
 *           not an empty market, so a mid-funnel 500 must never read as
 *           "nothing fits" and throw away the area the person just chose.
 */

/** True only when a successful count came back as zero after a non-empty one. */
export function marketEmptied(
  nextCount: number | null,
  previousCount: number | null,
): boolean {
  return nextCount === 0 && (previousCount ?? 0) > 0;
}

/** Keep the last known count when a refresh fails instead of flashing empty. */
export function keepCount(
  nextCount: number | null,
  previousCount: number | null,
): number | null {
  return nextCount === null ? previousCount : nextCount;
}

/**
 * Result counts show only below this many active listings (owner rule,
 * 2026-10-08, same rule as /properties). At or above it, no number is shown.
 */
export const RESULT_COUNT_DISPLAY_MAX = 1_500;

/** The active-listing count to print, or null when it must not be shown. */
export function displayableCount(count: number | null | undefined): number | null {
  if (count == null || !Number.isFinite(count) || count < 0) return null;
  return count < RESULT_COUNT_DISPLAY_MAX ? count : null;
}
